/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { ArticleProduct } from "@api/model";
import { initialize } from "redux-form";
import { Epic } from "redux-observable";
import FetchErrorHandler from "../../../../common/api/fetch-errors-handlers/FetchErrorHandler";
import * as EpicUtils from "../../../../common/epics/EpicUtils";
import { getEntityItemById } from "../../../entities/common/entityItemsService";
import { CHECKOUT_GET_ITEM_PRODUCT, CHECKOUT_GET_ITEM_PRODUCT_FULFILLED } from "../../actions/chekoutItem";
import { CHECKOUT_ITEM_EDIT_VIEW_FORM } from "../../components/items/components/CkecoutItemViewForm";

const request: EpicUtils.Request = {
  type: CHECKOUT_GET_ITEM_PRODUCT,
  getData: (id: number) => getEntityItemById("ArticleProduct", id),
  processData: (memberShipProduct: ArticleProduct) => [
      {
        type: CHECKOUT_GET_ITEM_PRODUCT_FULFILLED,
        payload: { editRecord: memberShipProduct }
      },
      initialize(CHECKOUT_ITEM_EDIT_VIEW_FORM, memberShipProduct)
    ],
  processError: response => [...FetchErrorHandler(response), initialize(CHECKOUT_ITEM_EDIT_VIEW_FORM, null)]
};

export const EpicCheckoutGetProduct: Epic<any, any> = EpicUtils.Create(request);
